import type { CmsLoginDialogModel } from '@/cms/components/overlays/cms-login-dialog-model';
import { mapCredentialAuthFlowCopy } from '@/lib/auth/credential-auth-flow-copy';
import type { AdminV2LoginPopupSceneSlug } from '@/site-runtime/code-owned/login-popup-scenes';
import type { SiteRuntimeGlobalSnapshot } from './types';

function readRequiredCopy(value: string, field: string) {
  if (!value.trim()) {
    throw new Error(`Site runtime login popup copy is empty: ${field}`);
  }
  return value;
}

export function buildSiteRuntimeLoginDialogModel(params: {
  popup: SiteRuntimeGlobalSnapshot['systemPopups']['login'];
  scene: AdminV2LoginPopupSceneSlug;
}): CmsLoginDialogModel | null {
  const sceneCopy = params.popup.scenes.find(
    (candidate) => candidate.slug === params.scene
  );
  if (!sceneCopy) {
    return null;
  }

  return {
    id: `site-runtime-login-${params.scene}`,
    title: readRequiredCopy(
      sceneCopy.title,
      `systemPopups.login.scenes.${params.scene}.title`
    ),
    description: readRequiredCopy(
      sceneCopy.body,
      `systemPopups.login.scenes.${params.scene}.body`
    ),
    googleButtonLabel: readRequiredCopy(
      params.popup.googleButtonLabel,
      'systemPopups.login.googleButtonLabel'
    ),
    credentialFlowCopy: mapCredentialAuthFlowCopy(
      params.popup.credentialFlowCopy,
      (value, fieldId) =>
        readRequiredCopy(
          value,
          `systemPopups.login.credentialFlowCopy.${fieldId}`
        )
    ),
    legalPrefix: readRequiredCopy(
      params.popup.legalCopy.prefix,
      'systemPopups.login.legalCopy.prefix'
    ),
    termsLabel: readRequiredCopy(
      params.popup.legalCopy.termsLabel,
      'systemPopups.login.legalCopy.termsLabel'
    ),
    privacyLabel: readRequiredCopy(
      params.popup.legalCopy.privacyLabel,
      'systemPopups.login.legalCopy.privacyLabel'
    ),
  };
}
